import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	completeSprintButton: {
		id: 'software.main.header.complete-sprint-button.complete-sprint-button',
		defaultMessage: 'Complete sprint',
		description: '',
	},
});
